import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    const apiUrl = window.CAHOOTS_CONFIG?.API_URL || '/api';
    fetch(`${apiUrl}/unsubscribe?token=${encodeURIComponent(token)}`, { method: 'POST' })
      .then((res) => {
        setStatus(res.ok ? 'success' : 'error');
      })
      .catch(() => setStatus('error'));
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--color-bg)',
      padding: '24px',
    }}>
      <div style={{
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
      }}>
        <img src="/icons/cottage.png" alt="Cahoots" width="48" height="48" style={{ marginBottom: '24px' }} />

        {status === 'loading' && (
          <p style={{ color: 'var(--color-text-muted)', fontSize: '16px' }}>Unsubscribing…</p>
        )}

        {status === 'success' && (
          <>
            <h1 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--color-text)', marginBottom: '12px' }}>
              You've been unsubscribed
            </h1>
            <p style={{ color: 'var(--color-text-muted)', fontSize: '16px', lineHeight: '1.6', marginBottom: '32px' }}>
              You won't receive any more emails from us. Your account is still active.
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '10px 24px',
              backgroundColor: 'var(--color-primary)',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
            }}>
              Back to Cahoots
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--color-text)', marginBottom: '12px' }}>
              That link didn't work
            </h1>
            <p style={{ color: 'var(--color-text-muted)', fontSize: '16px', lineHeight: '1.6', marginBottom: '32px' }}>
              The unsubscribe link may have expired or already been used. If you're still receiving unwanted emails, reply to one and we'll sort it out.
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '10px 24px',
              border: '1px solid var(--color-border)',
              color: 'var(--color-text)',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
            }}>
              Back to Cahoots
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
